import { render } from "./TuiDatePicker.vue?vue&type=template&id=5f1f548a&scoped=true"
import script from "./TuiDatePicker.vue?vue&type=script&lang=js"
export * from "./TuiDatePicker.vue?vue&type=script&lang=js"

import "./TuiDatePicker.vue?vue&type=style&index=0&id=5f1f548a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f1f548a"]])

export default __exports__